import React from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import Container from '@material-ui/core/Container';
import Avatar from '@material-ui/core/Avatar';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import nl2br from 'react-newline-to-break';
import {post} from './procedures';
import {googleSiteKey} from './procedures';
import {get_messages} from './procedures';

class Register extends React.Component  {
    constructor(props) {
        super(props);

        this.state = {errorStr: ''};

        this.state = {name2: ''};
        this.state = {httpd_username: ''};
        this.state = {password: ''};
        this.state = {password2: ''};

        this.state = {recaptchaRef: React.createRef()};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.emailChange = this.emailChange.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.password2Change = this.password2Change.bind(this);
        this.setErrorStr = this.setErrorStr.bind(this);

        get_messages('register_form_error', this.setErrorStr);
    }

    setErrorStr(add_errorStr) {
        let errorStr = this.state.errorStr;
        if (errorStr == undefined) { errorStr = '' }
        if (errorStr.length != 0) {
            //errorStr = errorStr.concat('\n');
            errorStr = '';
        }

        errorStr = errorStr.concat( add_errorStr );

        this.setState({errorStr: errorStr});
    }

    checkPasswords() {
        return this.state.password.localeCompare( this.state.password2 );
    }

    handleSubmit(event) {
        const checkPasswords = this.checkPasswords();
        if (checkPasswords == 0) {
            this.state.recaptchaRef.current.execute();
        }else{
            this.setErrorStr('Пароли не совпадают');
        }
    }

    handleRegister() {
        const recaptchaValue = this.state.recaptchaRef.current.getValue();

        var obj_tosend={};
        obj_tosend.action = 'register';
        obj_tosend.g_recaptcha_response = recaptchaValue;
        obj_tosend.httpd_username = this.state.httpd_username;
        obj_tosend.name2 = this.state.name2;
        obj_tosend.httpd_password = this.state.password;

        post('./tokensignin.php', obj_tosend);
    }

    nameChange(event) {
        this.setState({name2: event.target.value})
    }

    emailChange(event) {
        this.setState({httpd_username: event.target.value})
    }

    passwordChange(event) {
        this.setState({password: event.target.value})
    }

    password2Change(event) {
        this.setState({password2: event.target.value})
    }

    render() {
        //this.state.errorStr = get_messages('register_form_error');
        //this.setErrorStr('');

        return (

            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <PersonAddOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Регистрация
                    </Typography>
                    <form className={this.props.classes.form} noValidate>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="name"
                            label="Ваше имя (латинскими буквами)"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            onChange={this.nameChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="Email"
                            name="email"
                            autoComplete="email"
                            onChange={this.emailChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Пароль (латинскими буквами)"
                            type="password"
                            name="password"
                            onChange={this.passwordChange}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Подтвердите пароль"
                            type="password"
                            name="password2"
                            onChange={this.password2Change}
                        />
                        <div className={this.props.classes.error}>{ nl2br(this.state.errorStr) }</div>
                        <Grid container alignItems="center" className={this.props.classes.submitgrid}>
                            <Grid item xs>
                                <Button
                                    fullWidth
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    className={this.props.classes.submit}
                                    onClick={this.handleSubmit}
                                >
                                    Зарегистрироваться
                                </Button>
                            </Grid>
                        </Grid>
                        <br />
                        <div className={this.props.classes.linkCenter}>
                            <Link href="./" variant="body2">
                                Вход в портал
                            </Link>
                        </div>

                        <ReCAPTCHA ref={this.state.recaptchaRef}
                                   sitekey={googleSiteKey}
                                   size="invisible"
                                   onChange = {this.handleRegister}
                        />
                    </form>
                </div>
            </Container>

        )

    }

}

export default Register;